import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { CurrencyPairQuote, ExchangeRatesResponse } from './entities';
import { ForexRestful } from './restful';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'get_forex_quote_error' | 'get_exchange_rates_error';
  type: 'error';
}

export interface ForexEvent {
  quote: CurrencyPairQuote;
  type: 'forex:get_forex_quote';
}

export interface ForexExchangeRates {
  exchangeRates: ExchangeRatesResponse;
  type: 'forex:get_exchange_rates';
}

export type ForexRequestEvent = ErrorEvent | ForexEvent | ForexExchangeRates;

export class ForexRequest extends ListenableSubscribable<ForexRequestEvent> {
  private restful: ForexRestful;

  constructor(session: Session) {
    super();
    this.restful = new ForexRestful(session);
  }

  public getCurrencyPairQuote = async (currencyPair: string): SafePromise<CurrencyPairQuote> => {
    const response = await this.restful.getCurrencyPairQuote(currencyPair);
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'get_forex_quote_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        quote: response.ok,
        type: 'forex:get_forex_quote',
      });
    }
    return response;
  };

  public getExchangeRates = async (currency: string): SafePromise<ExchangeRatesResponse> => {
    const response = await this.restful.getExchangeRates(currency);
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'get_exchange_rates_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        exchangeRates: response.ok,
        type: 'forex:get_exchange_rates',
      });
    }
    return response;
  };
}
